import axios from 'axios';
import qs from 'qs';
import { authInterceptor, logout } from './auth-interceptor';

const apiVersion = '/api/v1';

export const http = axios.create({
  baseURL: `${apiVersion}`,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    },
  },
});

http.interceptors.response.use((result) => {
  // conditionally send fullResponse if needed
  if (
    typeof result === 'object' &&
    result !== null &&
    'config' in result &&
    result.config?.fullResponse
  ) {
    return result;
  }
  return result.data;
});

authInterceptor(http, {
  getAccessToken: () => {
    return localStorage.getItem('apiv1Auth');
  },

  shouldLogout: (error) => {
    const { config, response: { data = {} } = {} } = error;
    return (
      config.url !== '/auth' &&
      ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some((err) =>
        data?.errors?.includes?.(err)
      )
    );
  },

  shouldRefresh: (error) => {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return false;
    }
    const data = error?.response?.data || {};
    return data?.errors?.includes?.('err_token_expired');
  },

  logout: logout,
});
